import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaterialsDetailComponent } from './materials-detail/materials-detail.component';
import { MaterialsListComponent } from './materials-list/materials-list.component';

const routes: Routes = [
    {
        path: 'materials',
        children: [
            { path: '', component: MaterialsListComponent }
        ]
    },
    {
        path: 'materials/:id',
        children: [
            { path: '', component: MaterialsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MaterialsRoutingModule { }
